// TravelServices.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Route, FileCheck, Award, MessageSquare, CheckCircle } from 'lucide-react';

const TravelServices = () => {
  const services = [
    {
      id: 1,
      icon: Route,
      title: "Eligibility & route advice",
      description: "(study, work, visit, business, family)"
    },
    {
      id: 2,
      icon: FileCheck,
      title: "Document prep",
      description: "(forms, photos, translations, evidence)"
    },
    {
      id: 3,
      icon: Award,
      title: "Background certificates",
      description: "(police, employment, education)"
    },
    {
      id: 4,
      icon: MessageSquare,
      title: "Interview coaching & scheduling",
      description: ""
    },
    {
      id: 5,
      icon: CheckCircle,
      title: "Application assembly & QC",
      description: ""
    }
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div 
          className="text-left mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack">
            Travel & immigration services
          </h2>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <motion.div
                key={service.id}
                className="text-center"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                {/* Icon */}
                <div className="flex justify-center mb-6">
                  <div className="w-16 h-16 bg-acYellow rounded-full flex items-center justify-center">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-lg font-inter font-bold text-acBlack mb-2">
                  {service.title}
                </h3>
                {service.description && (
                  <p className="text-gray-600 leading-relaxed text-sm">
                    {service.description}
                  </p>
                )}
              </motion.div>
            );
          })}
        </div>

        {/* CTA */}
        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <Link 
            to="/travel" 
            className="inline-flex items-center bg-acBlack hover:bg-gray-800 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
          >
            → Book a Travel Consult
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default TravelServices;
